import { compact } from 'lodash';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { DelimitedList, ElectronicAccessDto } from '@app/components';
import { processElectronicAccess } from '@app/utils';

import { getExternalLink } from './utils';

const cnBem = createBemBlockBuilder(['instanceDetailsPage']);

export const formatElectronicAccess = (
  electronicAccess: ElectronicAccessDto[]
) => (
  <div className={cnBem('__externalLinkWrapper')}>
    {processElectronicAccess(electronicAccess).map(
      ({ linkText, uri, materialsSpecification, publicNote }) => (
        <div key={uri} className={cnBem('__externalLink')}>
          <DelimitedList
            items={compact([
              materialsSpecification,
              getExternalLink(linkText, uri),
              publicNote,
            ])}
            limit={1000}
            delimiter=", "
          />
        </div>
      )
    )}
  </div>
);
